import type { VariantProps } from "class-variance-authority"
import type { ReactNode } from "react"
import { Link } from "react-router"
import { buttonVariants } from "@/primitives/button.tsx"

/*
 * A way to another page that looks like a button: "Go home", "View all", "Browse Projects". It is
 * a link, and says so to a screen reader. A Button rendering a Link would carry Base UI's
 * `role="button"`, and navigation would be announced as an action on this page.
 */

/** A link to `to`, drawn as the Button of that `variant` and `size`, with the same defaults. */
export function ButtonLink({
  to,
  variant = "default",
  size = "default",
  children,
}: {
  to: string
  variant?: VariantProps<typeof buttonVariants>["variant"]
  size?: VariantProps<typeof buttonVariants>["size"]
  children: ReactNode
}) {
  return (
    <Link to={to} data-slot="button" className={buttonVariants({ variant, size })}>
      {children}
    </Link>
  )
}
